// Init vars
let dialogs = document.querySelectorAll('dialog[data-popup-mode]');
let openButtons = document.querySelectorAll('.jsOpenDialog');
let closeButtons = document.querySelectorAll('.jsCloseDialog');
let toggleMegamenuButtons = document.querySelectorAll('.jsToggleMegamenu');
let defaultLocalStoragePopupData = {
	// shown: '',
	closed: '',
	submitted: ''
}

// Handle various click events for dialogs & their buttons
window.addEventListener("load", function () {

	// Store hotkeys
	const hotkeyMap = {};

	// Open Buttons
	openButtons.forEach(btn => {
		btn.addEventListener('click', (event) => {
			event.preventDefault();
			showDialog(btn.dataset.dialogId);
		});

		// Map hotkeys if defined
		const hotkey = btn.dataset.hotkey;
		if (hotkey) {
			hotkeyMap[hotkey] = btn.dataset.dialogId;
		}
	});

	// Listen for hotkey presses
	document.addEventListener("keydown", (event) => {
		// Ignore hotkeys if the user is typing in an input, textarea, or contenteditable element
		if (["INPUT","TEXTAREA","SELECT"].includes(event.target.tagName) || event.target.isContentEditable) {
			return;
		}

		const key = event.key;
		if (hotkeyMap[key]) {

			// Prevents the key from being typed
			event.preventDefault();

			showDialog(hotkeyMap[key]);
		}
	});

	// Close Buttons
	closeButtons.forEach(btn => {
		btn.addEventListener('click', () => {
			closeDialog(btn.dataset.dialogId);
		});
	});

// Listen for close events on all dialogs
dialogs.forEach(dialog => {
	dialog.addEventListener("close", () => {
		// The native close event, not closeDialog(): ESC on a centered
		// (showModal) popup closes it natively without calling closeDialog().
		trackPopup('popup_close', dialog);

		// Remove active class from all linked megamenu buttons
		let allBtnsArr = document.querySelectorAll(`button[data-dialog-id="${dialog.id}"]`);
		allBtnsArr.forEach(b => b.classList.remove('megamenu-active'));

		// If no other megamenus are open, remove megamenu-shown class from html element
		if (document.querySelectorAll('dialog[data-popup-mode="megamenu"][open]').length === 0) {
			document.documentElement.classList.remove('megamenu-shown');
		}
	});
});

	// Toggle Megamenu Buttons
	toggleMegamenuButtons.forEach(btn => {
		btn.addEventListener('click', () => {
			// Get dialog associated with this button
			let dialog = document.getElementById(btn.dataset.dialogId);

			// If dialog is already open, close it and remove `megamenu-shown` class from html element
			if (dialog.hasAttribute('open')) {
				closeDialog(btn.dataset.dialogId);
				document.documentElement.classList.remove('megamenu-shown');
			// Else, close any other open megamenus, then open this one and add `megamenu-shown` class to html element
			} else {
				document.querySelectorAll('dialog[data-popup-mode="megamenu"][open]').forEach(d => {
					if (d.id !== btn.dataset.dialogId) {
						closeDialog(d.id);
					}
				});
				showDialog(btn.dataset.dialogId);
				// Add megamenu-shown class to html element and active class to this button
				document.documentElement.classList.add('megamenu-shown');
				btn.classList.add('megamenu-active');
			}
		});
	});

	// Dialogs
	dialogs.forEach(dialog => {

		// Backdrop clicks
		dialog.addEventListener('click', (event) => {
			// console.log(event.target.nodeName);

			if (event.target.nodeName === 'DIALOG') {
				closeDialog(dialog.id);
			}
		});

		// Click-throughs on anything clickable inside the popup except close.
		// link_url/link_text match GA4's own link-click parameter names.
		dialog.addEventListener('click', (event) => {
			const cta = event.target.closest('a[href], button:not(.jsCloseDialog)');
			if (!cta || !dialog.contains(cta)) return;

			trackPopup('popup_click', dialog, {
				link_url: cta.href || '',
				link_text: (cta.textContent || '').trim().slice(0, 100),
			});
		});

		// Auto-trigger conditions
		let currentTime = new Date();
		let storedCloseTime = getDialogClosedTime(dialog.id);
		if (storedCloseTime) {
			let difference = currentTime - storedCloseTime;
			let dialogCloseDurationInMs = dialog.dataset.closeDurationInDays * 24 * 60 * 60 * 1000;
			if (difference >= dialogCloseDurationInMs) {
				autotriggerPopup(dialog.id);
			}
		} else {
			autotriggerPopup(dialog.id);
		}

		// Watch for URL anchors specified in the data-trigger-keywords attr and open the dialog if those match
		if (dialog.dataset.triggerKeywords && dialog.dataset.triggerKeywords.trim() !== "") {
			const keywords = dialog.dataset.triggerKeywords.split(',');

			function checkHashAndShowDialog() {
				keywords.forEach(keyword => {
					if (window.location.hash === keyword.trim()) {
						showDialog(dialog.id);
					}
				});
			}

			window.addEventListener('hashchange', checkHashAndShowDialog);

			// Also check on initial load
			checkHashAndShowDialog();

			// Listen for clicks on anchor links and check hash after each click
			document.addEventListener('click', function (event) {
				const anchor = event.target.closest('a[href*="#"]');
				if (anchor) {
					// Use setTimeout to wait for hash to update
					setTimeout(checkHashAndShowDialog, 0);
				}
			});
		}
	});
});

// Push a popup event to the dataLayer for GTM to forward to GA4. Marketing
// popups only -- the give drawer and megamenus also go through
// showDialog()/closeDialog(), but aren't popups for reporting (the drawer is
// tracked by the donation funnel in donation-form.js instead).
function trackPopup(eventName, dialog, extra = {}) {
	if (!['corner', 'centered'].includes(dialog.dataset.popupMode)) return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		popup_id: dialog.id,
		popup_name: dialog.dataset.popupName || dialog.id,
		popup_mode: dialog.dataset.popupMode,
		popup_trigger: dialog.dataset.triggerType,
		// GTM's data model keeps keys from earlier pushes, so clear these or
		// a popup_click's link would carry over onto the next popup_close.
		link_url: undefined,
		link_text: undefined,
		...extra,
	});
}

// Listen for ESC key to close the dialog while it's open
function escKeyListener(event, dialogId) {
	if (event.key === "Escape") {
		closeDialog(dialogId);
	}
}

// Show a specific dialog
function showDialog(id) {
	let dialog = document.getElementById(id);
	if (devMode) console.info(`Opening ${dialog.dataset.popupMode} dialog #${id}.`);

	// Dismiss any other open popup (e.g. a marketing promo) before opening
	// the donation drawer -- jarring to have a promo popup sitting on top
	// of the donation form mid-flow, and it can visually collide with the
	// drawer. Goes through the same closeDialog() the popup's own [X]
	// button uses, so the close animation and "don't re-show for X days"
	// localStorage bookkeeping both behave exactly the same as a manual
	// dismissal.
	if (id === 'popup--give') {
		dialogs.forEach(otherDialog => {
			if (otherDialog.id !== id && otherDialog.hasAttribute('open')) {
				closeDialog(otherDialog.id);
			}
		});
	}

	// Re-showing an already-open popup (e.g. a hotkey pressed twice) isn't a
	// new view.
	const wasOpen = dialog.hasAttribute('open');

	try {
		switch (dialog.dataset.popupMode) {
			case 'corner':
				dialog.show();
				break;
			case 'centered':
				dialog.showModal();
				break;
			case 'drawer':
				// dialog.showModal(); // Not using a modal since Stripe/Plaid scripts in the donation form can generate elements via JS which get placed before </body>, rather than in the dialog, and therefore appear behind the modal dialog's backdrop
				dialog.show();

				// Listen for ESC key to close the dialog while it's open
				document.addEventListener("keydown", (event) => escKeyListener(event, dialog.id));
				// Remove the listener when the dialog is closed
				dialog.addEventListener("close", () => {
					document.removeEventListener("keydown", (event) => escKeyListener(event, dialog.id));
				})

				// Trap focus within the dialog
				dialog.addEventListener('keydown', (event) => trapFocus(event, dialog));
				// Remove focus trap when dialog closes
				dialog.addEventListener('close', () => {
					dialog.removeEventListener('keydown', (event) => trapFocus(event, dialog));
				});

				break;
			case 'megamenu':
				// dialog.showModal();
				dialog.show();

				// Listen for ESC key to close the dialog while it's open
				document.addEventListener("keydown", (event) => escKeyListener(event, dialog.id));
				// Remove the listener when the dialog is closed
				dialog.addEventListener("close", () => {
					document.removeEventListener("keydown", (event) => escKeyListener(event, dialog.id));
				})
				break;
			default:
				console.error(`Invalid popup mode "${dialog.dataset.popupMode}" on dialog #${id}`);
		}

		if (!wasOpen) trackPopup('popup_view', dialog);

		// Retrieve existing data from local storage (if any)
		// let popupData = JSON.parse(localStorage.getItem(id)) || defaultLocalStoragePopupData;

		// Get current date and time
		// let shownDate = new Date().toISOString();

		// popupData.shown = shownDate;

		// Store updated data
		// localStorage.setItem(id, JSON.stringify(popupData));
	} catch (error) {
		console.error(`Error in showing dialog #${id}`, error);
	}
}

/* // Watch for URL anchors and trigger dialog
function watchUrlAnchors() {
	const anchorMap = {
		'#give': 'popup--give',
		'#giving': 'popup--give',
		'#spenden': 'popup--give',
	};

	function checkAnchor() {
		const hash = window.location.hash;
		if (anchorMap[hash]) {
			showDialog(anchorMap[hash]);
		}
	}

	// Initial check on page load
	checkAnchor();

	// Listen for hash changes
	window.addEventListener('hashchange', checkAnchor);
}

// Initialize anchor watcher
watchUrlAnchors(); */

// Trap focus within the dialog while open
function trapFocus(event, dialog) {
	const focusableSelectors = [
		'a[href]',
		'area[href]',
		'input:not([disabled])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'button:not([disabled])',
		'iframe',
		'object',
		'embed',
		'[tabindex]:not([tabindex="-1"])',
		'[contenteditable]'
	];
	const focusableElements = dialog.querySelectorAll(focusableSelectors.join(','));
	if (focusableElements.length === 0) return;

	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	if (event.key === 'Tab') {
		if (event.shiftKey) {
			if (document.activeElement === firstElement) {
				event.preventDefault();
				lastElement.focus();
			}
		} else {
			if (document.activeElement === lastElement) {
				event.preventDefault();
				firstElement.focus();
			}
		}
	}
}

// Close Dialogs
function closeDialog(id) {
	let dialog = document.getElementById(id);
	if (devMode) console.info(`Closing dialog #${id}.`);

	try {
		dialog.close();

		// Retrieve existing data from local storage (if any)
		let popupData = JSON.parse(localStorage.getItem(id)) || defaultLocalStoragePopupData;

		// Get current date and time
		let closedDate = new Date().toISOString();

		popupData.closed = closedDate;

		// Store updated data
		localStorage.setItem(id, JSON.stringify(popupData));
	} catch (error) {
		console.error(`Error in closing dialog #${id}`, error);
	}
}

// Don't auto-trigger a marketing popup on top of the donation drawer --
// jarring for a donor mid-flow, and Stripe/Financial Connections elements
// the donation form injects can render behind a centered/corner popup's
// backdrop.
function isGiveDrawerOpen() {
	let giveDrawer = document.getElementById('popup--give');
	return !!(giveDrawer && giveDrawer.hasAttribute('open'));
}

// Same reasoning as isGiveDrawerOpen(), but for the inline (non-drawer)
// donation pages under /give/ -- e.g. /give/main-single-form. A donor
// filling out the form directly on the page deserves the same protection
// from an interrupting marketing popup as one using the sidebar drawer.
function isOnGivePage() {
	return window.location.pathname.startsWith('/give/');
}

function shouldSuppressAutoPopups() {
	return isGiveDrawerOpen() || isOnGivePage();
}

// Popup auto-trigger
function autotriggerPopup(id) {
	let dialog = document.getElementById(id);
	if (dialog.dataset.triggerType === "timeElapsed")
	{
		// Trigger after a specific time delay
		setTimeout(() => {
			if (shouldSuppressAutoPopups()) return;
			showDialog(id);
		}, dialog.dataset.timeElapsed * 1000);

	}
	else if (dialog.dataset.triggerType === "percentScrolled")
	{

		// Trigger when the user scrolls down a certain percentage of the page
		let triggered = false;

		window.addEventListener("scroll", function () {
			if (triggered) return;

			// Don't mark as triggered -- if suppressed when the threshold
			// is first crossed, keep checking on subsequent scroll events
			// so the popup still shows once the donor navigates away /
			// closes the drawer.
			if (shouldSuppressAutoPopups()) return;

			let scrollTop = window.scrollY;
			let docHeight = document.body.offsetHeight;
			let winHeight = window.innerHeight;
			let scrollPercent = scrollTop / (docHeight - winHeight);
			let scrollPercentRounded = Math.round(scrollPercent * 100);

			if (scrollPercentRounded >= dialog.dataset.percentScrolled) {
				triggered = true;
				showDialog(id);
			}
		});
	}
}

function isValidDate(date) {
	return date instanceof Date && !isNaN(date);
}

// Return a Date object of when the dialog was closed
function getDialogClosedTime(id) {
	// Retrieve existing data from local storage (if any)
	let popupData = JSON.parse(localStorage.getItem(id)) || defaultLocalStoragePopupData;
	if (popupData.closed) {
		try {
			let storedDate = new Date(popupData.closed);
			if (!isValidDate(storedDate)) {
				throw new Error('Invalid Date');
			}
			return storedDate;
		} catch (error) {
			console.error(error.message);
			return false;
		}
	} else {
		return false;
	}
}